<h1>Etapa 4: Plan de Mejoramiento</h1>
      <table class="table_card">
        <tr>
          <td>
            <mat-card class="reportes-card">
              <mat-card-header>
                <mat-card-title class="titulo_celeste">Resumen
                  <p>Plan de Mejoramiento</p>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <button mat-raised-button class="btn_morado" (click)="reporteVisible('resumen')">Ir</button>
              </mat-card-content>
            </mat-card>
          </td>
          <td>
            <mat-card class="reportes-card">
              <mat-card-header>
                <mat-card-title class="titulo_morado">Seguimiento
                  <p>Plan de Mejoramiento</p>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <button mat-raised-button class="btn_morado" (click)="reporteVisible('plan-seguimiento')">Ir</button>
              </mat-card-content>
            </mat-card>
          </td>
        </tr>
      </table>